import { ref, onMounted, onUnmounted } from 'vue';

/**
 * Composable for modal backdrop close that only closes when both mousedown AND
 * mouseup happen on the backdrop. Prevents accidental close when user clicks
 * on the modal, drags outside, and releases.
 *
 * @param {() => void} onClose - Callback to run when user completes a full click on the backdrop
 * @returns {{ mousedownOnBackdrop: Ref<boolean>, onBackdropMousedown: () => void, onBackdropMouseup: () => void, onContentMousedown: () => void }}
 */
export function useModalBackdropClose(onClose) {
  const mousedownOnBackdrop = ref(false);

  const onBackdropMousedown = () => {
    mousedownOnBackdrop.value = true;
  };

  const onBackdropMouseup = () => {
    if (mousedownOnBackdrop.value) {
      onClose();
    }
    mousedownOnBackdrop.value = false;
  };

  const onContentMousedown = () => {
    mousedownOnBackdrop.value = false;
  };

  const resetOnDocumentMouseup = () => {
    mousedownOnBackdrop.value = false;
  };

  onMounted(() => {
    document.addEventListener('mouseup', resetOnDocumentMouseup);
  });

  onUnmounted(() => {
    document.removeEventListener('mouseup', resetOnDocumentMouseup);
  });

  return {
    mousedownOnBackdrop,
    onBackdropMousedown,
    onBackdropMouseup,
    onContentMousedown
  };
}
